import React from 'react'
import PropTypes from 'prop-types'

import Button from '../../../Button'
import RefreshIcon from '../../../../assets/svg/Refresh'
import styles from '../HistoricalImagery.module.scss'

export function ImageryHeader(props) {
  const { isDisabled, isRefreshing } = props
  const handleRefreshClick = () => {
    props.handleRefreshClick()
  }
  return (
    <div className={styles.imageryHeaderContainer}>
      <Button disabled={isDisabled} size={Button.SIZE.small} theme={Button.THEME.solidSecondary} onClick={handleRefreshClick}>
        <i className={`${styles.refreshIcon} ${isRefreshing && styles.rotatingIcon}`}>
          <RefreshIcon disabled={isDisabled} />
        </i>
        {!isRefreshing ? ' Manual Refresh' : ' Refreshing...'}
      </Button>
    </div>
  )
}

ImageryHeader.propTypes = {
  isDisabled: PropTypes.bool,
  isRefreshing: PropTypes.bool,
  //  functions
  handleRefreshClick: PropTypes.func
}

export default ImageryHeader
